import React from 'react';

import { HelpIcon } from '../../assets/icons/HelpIcon';
import { StyledTooltipArrow, StyledTooltipText, StyledTooltip } from '../Styled';

export const Tooltip: React.FC<{ helpText: string }> = (props): JSX.Element => {
  const { helpText } = props;

  return (
    <StyledTooltip>
      <HelpIcon />
      <StyledTooltipText>
        {helpText}
        <StyledTooltipArrow />
      </StyledTooltipText>
    </StyledTooltip>
  );
};
